const Projects = [
  {
    id: 1,
    heading :"Sonder.com Clone",
    url : "https://sonder-clone.netlify.app/",
    img: "/images/p10.png",
    desc: "A Responsive Clone Of Famous Next.js Hotel Website in Simple Html, CSS & JS.",
    categories: ["HTML & CSS", "JavaScript","Splide.js"],
  },
  {
    id: 2,
    heading :"Live CryptoFolio",
    url : "https://myprojects-cryptofolio.netlify.app/",
    img: "images/p1.png",
    desc: "Tells Real-time Cryptocurrency Prices And Market Overview.",
    categories: ["JSX", "Live API","SASS"],
  },
  {
    id: 3,
    heading : "Expense-Tracker App",
    url : "https://myprojects-expense-tracker.netlify.app",
    img: "images/p7.png",
    desc: "Can Be Used To Track Your Income And Expenses At Very Ease.",
    categories: ["JSX", "Material UI", "Speechly"],
  },
  {
    id: 18,
    heading : "Car Website",
    url : "https://tiny-kheer-e0196b.netlify.app/",
    img: "images/p18.png",
    desc: "A Car Website With Three Working Contact Forms I made for Swedish client.",
    categories: ["Html & Css", "Bootstrap" , "SMTPJS"],
  },
  {
    id: 19,
    heading : "Youtube Stats Website",
    url : "https://upwork-client-13-german-45.netlify.app/",
    img: "images/p20.png",
    desc: "A responsive website that shows detailed YT stats of Arab Influencers.",
    categories: ["Html & Css", "Bootstrap" , "Sandbox"],
  },
  {
    id: 19,
    heading : "Simple University Site",
    url : "https://upwork-client-12-15-uni-site.netlify.app/",
    img: "images/p19.png",
    desc: "A 6-Page Simple Figma Design was converted to responsive html css bootstrap.",
    categories: ["Html & Css", "Bootstrap" , "Figma"],
  },
  {
    id: 17,
    heading : "Food Restaurant Website",
    url : "https://client-10fr-restaurant-aus.netlify.app/",
    img: "images/p17.png",
    desc: "Animation Rich Desi Food Restaurant Website on Pre-made Bootstrap Template.",
    categories: ["Html & Css", "Javascript", "Bootstrap"],
  },
  {
    id: 15,
    heading : "Restaurant Website SPA",
    url : "https://scintillating-dolphin-4ec29e.netlify.app/",
    img: "images/p15.png",
    desc: "A Single Page Hotel Website with 3 Pages(All Done with Javascript)",
    categories: ["Html & Css", "Javascript", "Bootstrap"],
  },
  {
    id: 16,
    heading : "Corporation Website",
    url : "https://ta-corporation.netlify.app/",
    img: "images/p16.png",
    desc: "A Corporation website with several pages and strong animations...",
    categories: ["HTML CSS", "Bootstrap", "AOS"],
  },
  {
    id: 4,
    heading : "Emoji-Search App",
    url : "https://myprojects-react-emojisearchapp.netlify.app/",
    img: "images/p2a.png",
    desc: "Can Be Used To Search 2000+ Emojis With Their Relevant Names.",
    categories: ["JSX", "RestApi","Filter Methods"],
  },
  {
    id: 5,
    heading : "Boreal Coffee-Shop Clone",
    url : "https://myprojects-coffeeshop.netlify.app/",
    img: "images/p3a.png",
    desc: "Clone Of The Well-Known Coffee Shop's Website.",
    categories: ["JSX","SASS", "React-Router"],
  },
  {
    id: 6,
    heading : "Ecommerce Store",
    url : "https://mezaanmart.com/",
    img: "images/p4a.png",
    desc: "An E-commerce Store That Is Made On Wordpress With WooCommerce Theme.",
    categories: ["Wordpress","Woo-Comm.", "PHP"],
  },
  {
    id: 7,
    heading : "Currency-Converter App",
    url : "https://myprojects-currencyconverter.netlify.app/",
    img: "images/p4b.png",
    desc: "An Awesome App That Can Convert Almost All Currencies Using Real-Time Data.",
    categories: ["JSX", "Live API", "LocalStorage"],
  },
  {
    id: 8,
    heading : "Fitness App",
    url : "https://myprojects-fitness-app.netlify.app/",
    img: "images/p5.png",
    desc: "A Simple Fitness App That Have 1200+ Excercises For You.",
    categories: ["JSX","SASS", "RestApi"],
  },
  {
    id: 9,
    heading : "To-Do List App",
    url : "https://myprojects-todoslist.netlify.app/",
    img: "images/p4.png",
    desc: "A Simple To-Do List App That Can Be Used To Add Or Remove Todos.",
    categories: ["JSX", "LocalStorage","React Icons"],
  },
  {
    id: 10,
    heading : "Live Weather App",
    img: "images/p3.png",
    url : "https://live-weather-forecasting-app.netlify.app/",
    desc: "An App That Can Tell Real-Time Weather Of Any City/Country/Region.",
    categories: ["JSX", "Live API", "React Icons"],
  },

  {
    id: 11,
    heading : "Netflix Clone",
    img: "images/p2.png",
    url : "https://myprojects-clone.netlify.app/",
    desc: "Clone Of The Well-Known OTT Platform Netflix's Website.",
    categories: ["JSX", "SASS", "React-Router"],
  },
  {
    id: 12,
    heading : "Analog Clock",
    url : "https://myprojects-analog-clock.netlify.app",
    img: "images/p6.png",
    desc: "A Simple Website That Shows Analog Clock With Alarm Functionality.",
    categories: ["JSX", "Dark/Light", "Alarm+Sound"],
  },
  {
    id: 13,
    heading : "CSS Gradient Generator",
    url : "https://master-gradient-generator.netlify.app/",
    img: "images/p8.png",
    desc: "A Website That Can Generate CSS Code Of Different Color Gradient.",
    categories: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 14,
    heading : "BG Color On Input",
    url : "https://myprojects-bg-changer.netlify.app/",
    img: "images/p9.png",
    desc: "Simple Website That Changes its Background Color On Color Name In Input.",
    categories: ["JSX", "React Hook", "CSS"],
  },
];

export default Projects;